import Skeleton from '../../../../shared/Skeleton';

export const ConfirmationCartSummarySkeleton = () => (
  <div className="confirmation__cart-summary-skeleton">
    <div className="confirmation__cart-summary-skeleton-section">
      <Skeleton width="100%" height="18px" borderRadius="4px" />
      <Skeleton width="20%" height="9px" borderRadius="4px" />
      <Skeleton width="52%" height="9px" borderRadius="4px" />
    </div>
    <div className="confirmation__cart-summary-skeleton-section">
      <Skeleton width="100%" height="9px" borderRadius="4px" />
      <Skeleton width="100%" height="9px" borderRadius="4px" />
    </div>
    <div className="confirmation__cart-summary-skeleton-section">
      <Skeleton width="100%" height="18px" borderRadius="4px" />
    </div>
  </div>
);
